/**
 * @returns difference of the two given arrays
 */
export const difference = <T>(array1: T[], array2: T[]) => array1.filter((value) => !array2.includes(value))
